import shippingMethodsCodes from './shippingMethodsCodes';

export default {
    [shippingMethodsCodes.PICKUP]: 'PICKUP',
    [shippingMethodsCodes.DPD]: 'DPD',
    [shippingMethodsCodes.CASTO]: 'CASTO',
    [shippingMethodsCodes.INPOST]: 'INPOST',
};
